import { Toast } from 'antd-mobile';
import type { ToastShowProps } from 'antd-mobile/es/components/toast';
import Lottie from 'lottie-react';
import loading from '@/lottie/loading.json';

/**
 * 全局 Toast 样式配置
 * 统一设置更大、更优雅的展示效果
 */
const defaultToastConfig: Partial<ToastShowProps> = {
  position: 'center',
  duration: 2000,
  className: 'ax-toast-content',
  maskClassName: 'ax-toast-mask',
  getContainer: () => document.body,
};

const AXToast = {
  /**
   * 显示 toast
   * @param config 配置选项
   * @returns Toast 实例，可以调用 close() 方法关闭
   */
  show: (config: ToastShowProps | string) => {
    const userConfig = typeof config === 'string' ? { content: config } : config;
    const finalConfig = { ...defaultToastConfig, ...userConfig };
    return Toast.show(finalConfig);
  },

  /**
   * 显示成功提示
   * @param content 提示内容
   * @param duration 显示时长，默认 2000ms
   */
  success: (content: string, duration: number = 2000) => {
    return Toast.show({
      ...defaultToastConfig,
      icon: 'success',
      content,
      duration,
    });
  },

  /**
   * 显示失败提示
   * @param content 提示内容
   * @param duration 显示时长，默认 2000ms
   */
  fail: (content: string, duration: number = 2000) => {
    return Toast.show({
      ...defaultToastConfig,
      icon: 'fail',
      content,
      duration,
    });
  },

  /**
   * 显示警告提示
   * @param content 提示内容
   * @param duration 显示时长，默认 2000ms
   */
  warn: (content: string, duration: number = 2000) => {
    return Toast.show({
      ...defaultToastConfig,
      icon: 'warn',
      content,
      duration,
    });
  },

  /**
   * 显示信息提示
   * @param content 提示内容
   * @param duration 显示时长，默认 2000ms
   */
  info: (content: string, duration: number = 2000) => {
    return Toast.show({
      ...defaultToastConfig,
      content,
      duration,
    });
  },

  loading: (content: string, duration: number = 2000) => {
    return Toast.show({
      ...defaultToastConfig,
      icon: <div className="w-40px h-40px">
        <Lottie animationData={loading} />
      </div>,
      content,
      duration,
      maskClassName: 'ax-loading',
    });
  },

  /**
   * 关闭所有 Toast
   */
  clear: () => {
    Toast.clear();
  },
};

export default AXToast;